/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';
import { stringify } from 'query-string';
import { Contact, ContactSearchByNumber } from './types';

export class ContactService extends AuthApiService {
  private apiUrl: string | undefined

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService())

    if (config.contact?.apiUrl)
      this.apiUrl = config.contact.apiUrl
    else
      console.error("CONTACT API CLIENT =>  config.contact.apiUrl is missing.")
    return this
  }

  public async getContactsByPhoneNumbers(phones: string | string[]) {
    const result = await this.masterAccountGetByPhoneNumbers<Record<string, ContactSearchByNumber[]>>({ phones });
    return result;
  }

  public async getContactDetailsById(contactId: number) {
    const result = await this.authFetch(`${this.apiUrl}/contacts/${contactId}`);
    return result.json() as Contact;
  }

  private async masterAccountGetByPhoneNumbers<T>(query: Record<string, string | string[]>) {
    const { masterAccountId } = (await this.oidcService.getClaims())!;
    return await this.get<T>(`${this.apiUrl}/master-accounts/${masterAccountId}/contacts-by-phones`, query);
  }

  private async get<T>(baseUrl: string, query: Record<string, string | number | string[]>) {
    const url = `${baseUrl}?${stringify(query)}`;
    const result = await this.authFetch(url);
    return result.json() as T;
  }

}
